// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__26NdT","controls":"styles_controls__2bI6Q","table":"styles_table__6F3aC"};